import AppTitle from '@theme/components/atom/AppTitle'

export default {
  name: 'CheckoutNextSteps',
  components: {
    AppTitle,
  },
}
